export default __webpack_public_path__ + "static/media/hospital-indemnity-icon.f3b6a0ec.svg";